<template>
  <router-view />
</template>

<script setup>
import { nextTick, provide, ref } from 'vue';

const isRouterAlive = ref(true);
function reload() {
  isRouterAlive.value = false;
  nextTick(() => {
    isRouterAlive.value = true;
  });
}
provide('reload', reload);
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  color: #828385;
}

body {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  /* overflow: hidden; */
}

.lv1 > .el-tree-node__content {
  color: #013F7D;
}

.lv2 > .el-tree-node__content {
  color: #1D77D0;
}

.lv3 > .el-tree-node__content {
  color: #71b8ff;
}

/* Global confirm/cancel button style for dialogs */
.el-dialog__footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.el-dialog__footer .el-button {
  min-width: 88px;
  border-radius: 6px;
}
.el-dialog__footer .el-button + .el-button {
  margin-left: 10px !important;
}

.el-dialog__footer .el-button:not(.el-button--primary) {
  color: #606266;
  border-color: #dcdfe6;
  background-color: #fff;
}

.el-dialog__footer .el-button--primary {
  color: #fff;
}

/* Unified button style for this.$confirm / ElMessageBox */
.el-message-box__btns {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.el-message-box__btns .el-button {
  min-width: 88px;
  border-radius: 6px;
}
.el-message-box__btns .el-button + .el-button {
  margin-left: 10px !important;
}

.el-message-box__btns .el-button:not(.el-button--primary) {
  color: #606266;
  border-color: #dcdfe6;
  background-color: #fff;
}

.el-message-box__btns .el-button--primary {
  color: #fff;
}

/* Dialog footer: keep left-side success buttons blue without changing other success buttons */
.el-dialog__footer > .el-button--success:first-child,
.el-dialog__footer > .el-button--warning:first-child,
.el-dialog__footer .dialog-footer > .el-button--success:first-child,
.el-dialog__footer .dialog-footer > .el-button--warning:first-child,
.el-dialog__footer .box-dialog-footer > .el-button--success:first-child {
  color: #fff !important;
  border-color: #409eff !important;
  background-color: #409eff !important;
}

/* Support wrapped left-side button groups */
.el-dialog__footer > .dialog-footer > div:first-child > .el-button--success:first-child,
.el-dialog__footer > .dialog-footer > div:first-child > .el-button--warning:first-child,
.el-dialog__footer > .box-dialog-footer > div:first-child > .el-button--success:first-child,
.el-dialog__footer > .box-dialog-footer > div:first-child > .el-button--warning:first-child {
  color: #fff !important;
  border-color: #409eff !important;
  background-color: #409eff !important;
}

/* Page bottom-left button groups use blue success/warning buttons */
.el-row .export > .el-button--success,
.el-row .export > .el-button--warning,
.el-row .export .el-button--success,
.el-row .export .el-button--warning,
.goos-left > .el-button--success,
.goos-left > .el-button--warning,
.bo-warehousing-left > .el-button--success,
.bo-warehousing-left > .el-button--warning,
.bo-goods-left > .el-button--success,
.bo-goods-left > .el-button--warning,
.look-left > .el-button--success,
.look-left > .el-button--warning {
  color: #fff !important;
  border-color: #409eff !important;
  background-color: #409eff !important;
}
</style>
